import { Reveal } from "./Reveal";

const Contact = () => {
  return (
    <section id="contact" className="wrap contact-section" style={{ padding: "0 40px 96px" }} data-testid="contact-section">
      <Reveal>
        <div style={{ borderTop: "1px solid var(--hairline)", paddingTop: 56, marginBottom: 48 }}>
          <div className="eyebrow" style={{ marginBottom: 16 }}>Contact</div>
          <h2 style={{ margin: 0, fontSize: "var(--display-lg-size)", lineHeight: "var(--display-lg-lh)", letterSpacing: "var(--display-lg-ls)", fontWeight: "var(--weight-thin)", color: "var(--ink)" }}>
            Get in touch
          </h2>
        </div>
      </Reveal>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 340px), 1fr))", gap: 32 }}>
        <Reveal style={{ display: "flex" }}>
          <div className="work-card" style={{ flex: 1, gap: 16 }} data-testid="contact-card-call">
            <h3 style={{ margin: 0, fontSize: "var(--heading-md-size)", lineHeight: "var(--heading-md-lh)", letterSpacing: "var(--heading-md-ls)", fontWeight: 400, color: "var(--ink)", textWrap: "pretty" }}>
              Want help automating workflows in your firm or legal team?
            </h3>
            <p style={{ margin: "0 0 8px", fontSize: "var(--body-md-size)", lineHeight: 1.7, fontWeight: "var(--weight-thin)", color: "var(--ink-secondary)" }}>
              I've done this for Indian firms and lenders — in-house and hands-on. For consulting, book a call or write to:
            </p>
            <div style={{ display: "flex", alignItems: "center", gap: 20, marginTop: "auto", flexWrap: "wrap" }}>
              <a href="https://calendly.com/ssrvaishnav133/30min" target="_blank" rel="noopener" style={{ textDecoration: "none" }}>
                <button type="button" className="btn-primary" style={{ minWidth: 120, height: 36 }} data-testid="book-call-btn">Book a call</button>
              </a>
              <a href="mailto:ssrvaishnav133@gmail.com" className="link-primary" style={{ fontSize: "var(--body-md-size)", fontWeight: "var(--weight-thin)" }} data-testid="contact-email-link">
                Email <span className="arrow">→</span>
              </a>
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.08} style={{ display: "flex" }}>
          <div className="work-card" style={{ flex: 1, gap: 16 }} data-testid="contact-card-other">
            <h3 style={{ margin: 0, fontSize: "var(--heading-md-size)", lineHeight: "var(--heading-md-lh)", letterSpacing: "var(--heading-md-ls)", fontWeight: 400, color: "var(--ink)" }}>Something else?</h3>
            <p style={{ margin: "0 0 8px", fontSize: "var(--body-md-size)", lineHeight: 1.7, fontWeight: "var(--weight-thin)", color: "var(--ink-secondary)" }}>
              Comparing notes, an interesting problem, or an argument with something I've written — I read everything. For anything other than consulting, write to:
            </p>
            <div style={{ marginTop: "auto" }}>
              <a href="mailto:rajesh@lawseek.ai" className="link-primary" style={{ fontSize: "var(--body-md-size)", fontWeight: "var(--weight-thin)" }} data-testid="lawseek-email-link">
                Email <span className="arrow">→</span>
              </a>
            </div>
          </div>
        </Reveal>
      </div>

    </section>
  );
};

export default Contact;
